import axiosInstance from '../components/utils/axios/axiosInstance';
import { GET_ALL_USERS_DONE } from './constantsActions';

export function getAllUsersDone(users) {
  return {
    type: GET_ALL_USERS_DONE,
    payload: users
  };
}

export function getAllUsers() {
  return async (dispatch) => {
    const { data } = await axiosInstance.get(`/api/user/all`);
    dispatch(getAllUsersDone(data));
  };
}
